import React from 'react'
import { ButtonLoading, InputSwitch } from '../../../Simple'
import { Grid, Typography } from '@mui/material'
import SettingsHook from '../SettingsHook'

import { stMob } from './styles'

export default function EnviarEmails() {
  const { inpsStt, loadStt, actionsSettings } = SettingsHook()

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography sx={stMob.labelPage} variant='body1'>
          Aqui você pode configurar quando deseja receber avisos em seu e-mail. Notificações push
          sempre serão enviadas, você pode desativá-las diretamente pelo seu sistema.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <InputSwitch
          info='Novos agendamentos'
          value={inpsStt.newReserva}
          onChange={() => actionsSettings.handleInpsStt('newReserva', !inpsStt.newReserva)}
        />
      </Grid>
      <Grid item xs={12}>
        <InputSwitch
          info='Agendamentos aprovados'
          value={inpsStt.newReservaAprovada}
          onChange={() =>
            actionsSettings.handleInpsStt('newReservaAprovada', !inpsStt.newReservaAprovada)
          }
        />
      </Grid>
      <Grid item xs={12}>
        <InputSwitch
          info='Agendamentos cancelados'
          value={inpsStt.newReservacancelada}
          onChange={() =>
            actionsSettings.handleInpsStt('newReservacancelada', !inpsStt.newReservacancelada)
          }
        />
      </Grid>
      <Grid item xs={12}>
        <ButtonLoading loading={loadStt.envioEmails} label='Alterar Senha' onClick={() => {}}>
          Alterar envio de e-mails
        </ButtonLoading>
      </Grid>
    </Grid>
  )
}
